/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceEventFinanceStatsDto { 
    /**
     * Organizer earning in cents
     */
    organizerEarningCents: number;
    /**
     * Platform earning in cents
     */
    platformEarningCents: number;
    /**
     * Number of tickets sold
     */
    ticketsSold: number;
    /**
     * Event revenue in cents
     */
    eventRevenueCents?: number;
    /**
     * Currency
     */
    currency: string;
    /**
     * Commission percentage
     */
    commissionPercentage?: number;
}

